import React, { useEffect } from "react";
import { Icon, Menu } from "semantic-ui-react";
import { useAuth, useSiteConfig } from "../../../hooks";
import { ReadyAlert } from "./ReadyAlert";
import defaultDeveloperLogo from "../../../assets/tallansoft.png";
import "./TopMenu.scss";

export function TopMenu(props) {
  const { onToggleMenu } = props;
  const { auth, logout } = useAuth();
  const { siteConfig, loading, getSiteConfig } = useSiteConfig();

  useEffect(() => {
    getSiteConfig();
  }, []);

  // Solo el nombre, sin apellidos: con el nombre completo (ej. "Juan Victor
  // Sanchez Helfer") el recuadro — que es también el botón de cerrar sesión —
  // se salía por la derecha en pantallas angostas.
  const renderName = () =>
    auth.me?.first_name || auth.me?.username || auth.me?.email;

  return (
    <Menu fixed="top" className="top-menu-admin">
      <Menu.Item
        className="top-menu-admin__toggle"
        title="Menú"
        onClick={onToggleMenu}
      >
        <Icon name="bars" size="large" />
      </Menu.Item>

      {/* Logo 1: la marca del desarrollador del sistema (como Restaurant.pe).
          La del restaurante (logo 2) va en la cabecera del menú ☰. */}
      <Menu.Item className="top-menu-admin__logo">
        {!loading && (
          <>
            <img src={siteConfig?.developer_logo || defaultDeveloperLogo} alt="" />
            {siteConfig?.developer_name && (
              <span className="top-menu-admin__site-name">
                {siteConfig.developer_name}
              </span>
            )}
          </>
        )}
      </Menu.Item>

      <Menu.Menu position="right">
        <ReadyAlert />
        <Menu.Item
          className="top-menu-admin__user"
          title="Cerrar sesión"
          onClick={logout}
        >
          <span>{renderName()}</span>
          <Icon name="sign-out" />
        </Menu.Item>
      </Menu.Menu>
    </Menu>
  );
}
